import React, { useState } from 'react';

import { UserRole } from '@shared/types/user_role';

import { Panel } from '@admin/components/helpers/panel';
import { client } from '@admin/libraries/apollo';
import { Claim__FiltersInput, Claim__Status, UserFragment, useUsersSelectorQuery } from '@admin/schema';

export const Filters: React.FC<{
  query?: string;
  status?: Claim__Status;
  ownerID?: string;
  hasDamagedItem?: boolean;
  hasDamagedProperty?: boolean;
  hasLostItem?: boolean;
  hasIssue?: boolean;
  onQuery(query?: string): void;
  onStatus(status?: Claim__Status): void;
  onOwnerID(ownerID?: string): void;
  onHasDamagedItem(hasDamagedItem?: boolean): void;
  onHasDamagedProperty(hasDamagedProperty?: boolean): void;
  onHasLostItem(hasLostItem?: boolean): void;
  onHasIssue(hasIssue?: boolean): void;
}> = ({
  query,
  status,
  ownerID,
  hasDamagedItem,
  hasDamagedProperty,
  hasLostItem,
  hasIssue,
  onQuery,
  onStatus,
  onOwnerID,
  onHasDamagedItem,
  onHasDamagedProperty,
  onHasLostItem,
  onHasIssue,
}) => {
  const [owners, setOwners] = useState<UserFragment[]>([]);

  useUsersSelectorQuery({
    client,
    variables: { filters: { role: UserRole.Claims } },
    onCompleted: (data) => setOwners(data.users),
  });

  return (
    <Panel>
      <Panel.Body>
        <div className="form">
          <div className="form-group">
            <input
              value={query ?? ''}
              onChange={(event) => onQuery(event.target.value || undefined)}
              placeholder="Search by customer name, account number, email, phone number"
              className="form-control"
            />
          </div>
        </div>
        <div className="form-inline">
          <div className="form-group">
            <label className="mar-hor">
              <strong>Status: </strong>
            </label>
            <select
              className="form-control"
              value={status ?? ''}
              onChange={(event) => onStatus((event.target.value as Claim__Status) || undefined)}
            >
              <option value="">All</option>
              {(Object.keys(Claim__Status) as Array<keyof typeof Claim__Status>).map((status) => (
                <option key={status} value={Claim__Status[status]}>
                  {status === 'InReview' ? 'In Review' : status}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="mar-hor">
              <strong>Assignee: </strong>
            </label>
            <select
              id="owner-select"
              className="form-control"
              value={ownerID ?? ''}
              onChange={(event) => onOwnerID(event.target.value || undefined)}
            >
              <option value="">All</option>
              <option value="unassigned">Unassigned</option>
              {owners.map((owner) => (
                <option key={owner.id} value={owner.id}>
                  {owner.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="mar-hor">
              <strong>Kind: </strong>
            </label>
            <div className="checkbox-inline">
              <label>
                <input
                  checked={!hasDamagedItem}
                  type="checkbox"
                  onChange={(event) => onHasDamagedItem(event.target.checked || undefined)}
                />
                Damage
              </label>
            </div>
            <div className="checkbox-inline">
              <label>
                <input
                  checked={!!hasLostItem}
                  type="checkbox"
                  onChange={(event) => onHasLostItem(event.target.checked || undefined)}
                />
                Lost
              </label>
            </div>
            <div className="checkbox-inline">
              <label>
                <input
                  checked={!!hasDamagedProperty}
                  type="checkbox"
                  onChange={(event) => onHasDamagedProperty(event.target.checked || undefined)}
                />
                Property
              </label>
            </div>
            <div className="checkbox-inline">
              <label>
                <input
                  checked={!hasIssue}
                  type="checkbox"
                  onChange={(event) => onHasIssue(event.target.checked || undefined)}
                />
                Issue
              </label>
            </div>
          </div>
        </div>
      </Panel.Body>
    </Panel>
  );
};
